"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIFeatures = void 0;
exports.UIFeatures = {
    Tabs: 'tabs',
    Tools: 'tools',
    SaveScreen: 'save_screen',
    Record: 'record',
    AR: 'ar',
    Tips: 'tips',
    SaveImage: 'save_image',
    NewScreensTooltip: 'new_screens_tooltip',
};
